import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export function DelivererForm({ onClose }) {
  const { authAxios } = useAuth();
  const [form, setForm] = useState({ name: "", phone: "", vehicle: "moto" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAxios.post("/deliverers", form);
      toast.success("Entregador adicionado");
      onClose();
    } catch {
      toast.error("Erro ao adicionar");
    }
    setLoading(false);
  };

  return (
    <>
      <DialogHeader>
        <DialogTitle className="text-xl">Novo Entregador</DialogTitle>
      </DialogHeader>
      <form onSubmit={handleSubmit} className="space-y-4 mt-4">
        <div className="space-y-2">
          <Label>Nome</Label>
          <Input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} required data-testid="deliverer-name-input" />
        </div>
        <div className="space-y-2">
          <Label>Telefone</Label>
          <Input value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} required data-testid="deliverer-phone-input" />
        </div>
        <div className="space-y-2">
          <Label>Veiculo</Label>
          <Select value={form.vehicle} onValueChange={v => setForm(p => ({ ...p, vehicle: v }))}>
            <SelectTrigger data-testid="deliverer-vehicle-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="moto">Moto</SelectItem>
              <SelectItem value="bici">Bicicleta</SelectItem>
              <SelectItem value="coche">Carro</SelectItem>
              <SelectItem value="patinete">Patinete</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <DialogFooter>
          <Button type="button" variant="secondary" onClick={onClose}>Cancelar</Button>
          <Button type="submit" disabled={loading} data-testid="save-deliverer-btn">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Guardar"}
          </Button>
        </DialogFooter>
      </form>
    </>
  );
}
